import React, { useState } from 'react';
import styled from 'styled-components';
import { EyeOutlined, EyeInvisibleOutlined } from '@ant-design/icons';
import { initialColors } from 'helpers/ColorHelper';

const StyledDiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 15px;
  width: 50%;
`;

const StyledH5 = styled.h5`
  margin-top: 5px;
  margin-bottom: 0;
  color: #6f6f6f;
`;

const MaskedText = ({ secretValue, maskValue }) => {
  const [masked, setMasked] = useState(true);

  const toggleMasked = () => {
    setMasked(!masked);
  };

  let sinValue = maskValue;
  let icon = <EyeOutlined style={{ color: initialColors.ULTRAMARINE_BLUE }} />;

  if (!masked) {
    sinValue = secretValue;
    icon = <EyeInvisibleOutlined style={{ color: initialColors.ULTRAMARINE_BLUE }} />;
  }

  return (
    <StyledDiv>
      <StyledH5>{sinValue}</StyledH5>
      <StyledH5 onClick={toggleMasked} style={{ cursor: 'pointer' }}>
        {icon}
      </StyledH5>
    </StyledDiv>
  );
};

export default MaskedText;
